// extracted by mini-css-extract-plugin
export default {"content":"LegalNoticePage_content__A7rRj"};